/* IC Kartstore navigation and filter preview v1 — unpublished theme only. */
(function () {
  'use strict';

  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function emit(eventName, detail) {
    const payload = Object.assign({ event: eventName }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('ic:measurement', { detail: payload }));
  }

  function visibleFocusable(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll(FOCUSABLE)).filter(function (element) {
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab') return;
    const items = visibleFocusable(container);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setScrollLock() {
    const navOpen = document.querySelector('[data-ic-site-header][data-mobile-open="true"]');
    const filterOpen = document.body.getAttribute('data-ic-filter-open') === 'true';
    document.body.classList.toggle('ic-scroll-locked', Boolean(navOpen || filterOpen));
  }

  function initialiseDesktopNavigation() {
    const nav = document.querySelector('[data-ic-primary-nav]');
    if (!nav) return;
    const items = Array.from(nav.querySelectorAll('[data-ic-nav-item]'));
    let closeTimer = null;
    let lastTrigger = null;

    function setItem(item, open, source) {
      const trigger = item && item.querySelector('[data-ic-nav-trigger]');
      const panel = item && item.querySelector('[data-ic-nav-panel]');
      if (!trigger || !panel) return;
      const alreadyOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
      item.classList.toggle('is-open', open);
      if (open) {
        item.setAttribute('data-ic-open-source', source || 'unknown');
        lastTrigger = trigger;
        items.forEach(function (other) {
          if (other !== item) setItem(other, false);
        });
        if (!alreadyOpen) emit('ic_menu_open', { menu_label: trigger.textContent.trim(), device: 'desktop', source: source || 'unknown' });
      } else {
        item.removeAttribute('data-ic-open-source');
      }
    }

    function closeAll(options) {
      items.forEach(function (item) { setItem(item, false); });
      if (options && options.restoreFocus && lastTrigger) lastTrigger.focus();
    }

    items.forEach(function (item) {
      const trigger = item.querySelector('[data-ic-nav-trigger]');
      const panel = item.querySelector('[data-ic-nav-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        const alreadyOpen = trigger.getAttribute('aria-expanded') === 'true';
        const openedByClick = item.getAttribute('data-ic-open-source') === 'click';
        const willOpen = !alreadyOpen || !openedByClick;
        setItem(item, willOpen, 'click');
      });
      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        window.clearTimeout(closeTimer);
        setItem(item, true, 'hover');
      });
      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'touch') return;
        closeTimer = window.setTimeout(function () { setItem(item, false); }, 160);
      });
      item.addEventListener('focusin', function (event) {
        window.clearTimeout(closeTimer);
        if (event.target !== trigger) setItem(item, true, 'keyboard');
      });
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) setItem(item, false);
        }, 0);
      });
    });

    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.querySelector('[data-ic-nav-trigger][aria-expanded="true"]')) {
        event.preventDefault();
        closeAll({ restoreFocus: true });
      }
    });
  }

  function initialiseMobileNavigation() {
    const header = document.querySelector('[data-ic-site-header]');
    const toggle = header && header.querySelector('[data-ic-mobile-nav-toggle]');
    const drawer = header && header.querySelector('[data-ic-mobile-drawer]');
    if (!header || !toggle || !drawer) return;
    let previouslyFocused = null;

    function setDrawer(open, options) {
      const wasOpen = header.getAttribute('data-mobile-open') === 'true';
      header.setAttribute('data-mobile-open', String(open));
      drawer.classList.toggle('active', open);
      drawer.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      const icon = toggle.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-bars', !open);
        icon.classList.toggle('fa-xmark', open);
      }
      setScrollLock();
      if (open && !wasOpen) {
        previouslyFocused = document.activeElement;
        emit('ic_menu_open', { menu_label: 'Mobile navigation', device: 'mobile', source: (options && options.source) || 'toggle' });
        if (!options || options.moveFocus !== false) {
          window.setTimeout(function () {
            const first = drawer.querySelector('[data-ic-mobile-nav-close]') || visibleFocusable(drawer)[0];
            if (first) first.focus();
          }, 30);
        }
      } else if (!open && wasOpen && options && options.restoreFocus) {
        (previouslyFocused || toggle).focus();
      }
    }

    toggle.addEventListener('click', function () {
      const before = drawer.classList.contains('active');
      window.requestAnimationFrame(function () {
        const afterLegacyHandler = drawer.classList.contains('active');
        setDrawer(afterLegacyHandler === before ? !before : afterLegacyHandler, { source: 'toggle' });
      });
    });

    header.querySelectorAll('[data-ic-mobile-nav-close]').forEach(function (button) {
      button.addEventListener('click', function () { setDrawer(false, { restoreFocus: true }); });
    });

    drawer.querySelectorAll('.ic-mobile-disclosure').forEach(function (button) {
      const submenu = document.getElementById(button.getAttribute('aria-controls'));
      if (!submenu) return;
      button.addEventListener('click', function () {
        const before = button.classList.contains('active');
        window.requestAnimationFrame(function () {
          const afterLegacyHandler = button.classList.contains('active');
          const open = afterLegacyHandler === before ? !before : afterLegacyHandler;
          button.classList.toggle('active', open);
          button.setAttribute('aria-expanded', String(open));
          submenu.setAttribute('aria-hidden', String(!open));
          submenu.style.maxHeight = open ? submenu.scrollHeight + 'px' : '0px';
        });
      });
    });

    drawer.addEventListener('keydown', function (event) {
      if (header.getAttribute('data-mobile-open') !== 'true') return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setDrawer(false, { restoreFocus: true });
      } else {
        trapTab(event, drawer);
      }
    });
  }

  function initialiseMenuMeasurement() {
    document.querySelectorAll('[data-ic-menu-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        emit('ic_menu_click', {
          menu_label: link.textContent.trim(),
          destination: link.getAttribute('href'),
          device: link.closest('.ic-mobile-menu') ? 'mobile' : 'desktop'
        });
      });
    });
  }

  function initialiseCollectionDiscovery() {
    const panel = document.querySelector('[data-ic-filter-panel]');
    const openButton = document.querySelector('[data-ic-filter-open]');
    if (!panel) return;
    const form = panel.closest('form');
    let previouslyFocused = null;

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function setPanel(open, options) {
      const useDrawer = isMobile();
      panel.setAttribute('aria-hidden', String(useDrawer ? !open : false));
      document.body.setAttribute('data-ic-filter-open', String(useDrawer && open));
      if (openButton) openButton.setAttribute('aria-expanded', String(useDrawer && open));
      setScrollLock();
      if (useDrawer && open) {
        previouslyFocused = document.activeElement;
        emit('ic_filter_open', { collection: window.location.pathname, active_filter_count: Number(panel.dataset.activeFilterCount || 0) });
        window.setTimeout(function () {
          const first = panel.querySelector('[data-ic-filter-close]') || visibleFocusable(panel)[0];
          if (first) first.focus();
        }, 30);
      } else if (options && options.restoreFocus && previouslyFocused) {
        previouslyFocused.focus();
      }
    }

    if (openButton) openButton.addEventListener('click', function () { setPanel(true); });
    document.querySelectorAll('[data-ic-filter-close]').forEach(function (button) {
      button.addEventListener('click', function () { setPanel(false, { restoreFocus: true }); });
    });

    panel.addEventListener('keydown', function (event) {
      if (document.body.getAttribute('data-ic-filter-open') !== 'true') return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setPanel(false, { restoreFocus: true });
      } else {
        trapTab(event, panel);
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) setPanel(false);
    });
    setPanel(false);

    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('[data-ic-price-range]').forEach(function (range) {
          const multiplier = Number(range.dataset.vatMultiplier || 1) || 1;
          ['min', 'max'].forEach(function (edge) {
            const visible = range.querySelector('[data-ic-price-display="' + edge + '"]');
            const native = range.querySelector('[data-ic-price-native="' + edge + '"]');
            if (!visible || !native) return;
            const raw = visible.value.trim();
            native.value = raw === '' ? '' : Math.max(0, Number(raw) / multiplier).toFixed(2);
            native.disabled = native.value === '' || !Number.isFinite(Number(native.value));
          });
        });
        emit('ic_filter_apply', {
          collection: window.location.pathname,
          active_filter_count: form.querySelectorAll('input[type="checkbox"]:checked').length,
          price_used: Array.from(form.querySelectorAll('[data-ic-price-display]')).some(function (input) { return input.value.trim() !== ''; })
        });
      });
    }

    document.querySelectorAll('[data-ic-filter-remove]').forEach(function (link) {
      link.addEventListener('click', function () {
        emit('ic_filter_remove', { collection: window.location.pathname, filter: link.textContent.trim() });
      });
    });
    document.querySelectorAll('[data-ic-filter-clear]').forEach(function (link) {
      link.addEventListener('click', function () { emit('ic_filter_clear', { collection: window.location.pathname }); });
    });

    const sort = document.querySelector('[data-ic-sort]');
    if (sort && form) {
      sort.addEventListener('change', function () {
        emit('ic_sort_change', { collection: window.location.pathname, sort_by: sort.value });
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }

  function initialiseBrandDirectory() {
    const root = document.querySelector('[data-ic-brand-directory]');
    if (!root) return;
    const search = root.querySelector('[data-ic-brand-search]');
    const clear = root.querySelector('[data-ic-brand-search-clear]');
    const grid = root.querySelector('[data-ic-brand-grid]');
    const sort = root.querySelector('[data-ic-brand-sort]');
    const count = root.querySelector('[data-ic-brand-result-count]');
    const zero = root.querySelector('[data-ic-brand-zero]');
    const zeroLink = root.querySelector('[data-ic-brand-zero-link]');
    if (!search || !grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-brand-card]'));
    let searchTimer = null;

    function normalise(value) {
      return String(value || '').toLocaleLowerCase('en-GB').replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function render() {
      const query = normalise(search.value);
      let visible = 0;
      cards.forEach(function (card) {
        const match = !query || normalise(card.dataset.brandName).includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = visible + ' brand' + (visible === 1 ? '' : 's');
      if (zero) zero.hidden = visible !== 0;
      if (zeroLink) zeroLink.href = query ? '/search?type=product&q=' + encodeURIComponent(search.value.trim()) : '/collections/all-products';
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () {
        emit('ic_brand_search', { query: search.value.trim(), result_count: visible });
      }, 400);
    }

    function sortCards() {
      const mode = sort ? sort.value : 'az';
      cards.sort(function (a, b) {
        if (mode === 'count') return Number(b.dataset.brandCount || 0) - Number(a.dataset.brandCount || 0) || a.dataset.brandName.localeCompare(b.dataset.brandName, 'en-GB');
        const direction = mode === 'za' ? -1 : 1;
        return direction * a.dataset.brandName.localeCompare(b.dataset.brandName, 'en-GB');
      }).forEach(function (card) { grid.appendChild(card); });
      render();
    }

    search.addEventListener('input', render);
    if (clear) clear.addEventListener('click', function () { search.value = ''; render(); search.focus(); });
    if (sort) sort.addEventListener('change', sortCards);
    sortCards();
  }

  function initialiseBreadcrumbMeasurement() {
    document.querySelectorAll('[data-ic-product-breadcrumb] a').forEach(function (link) {
      link.addEventListener('click', function () {
        emit('ic_product_breadcrumb_click', { destination: link.getAttribute('href'), label: link.textContent.trim() });
      });
    });
  }

  window.addToCart = function (variantId, button) {
    const trigger = button && button.nodeType === 1 ? button : null;
    if (!variantId) return Promise.reject(new Error('A variant ID is required.'));
    if (trigger) {
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add this product to the cart.');
      return response.json();
    }).then(function (data) {
      emit('ic_quick_add', { variant_id: String(variantId), source: 'collection' });
      if (trigger) trigger.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      return data;
    }).catch(function (error) {
      if (trigger) trigger.textContent = 'Try again';
      throw error;
    }).finally(function () {
      if (trigger) {
        trigger.disabled = false;
        trigger.removeAttribute('aria-busy');
      }
    });
  };

  function initialise() {
    initialiseDesktopNavigation();
    initialiseMobileNavigation();
    initialiseMenuMeasurement();
    initialiseCollectionDiscovery();
    initialiseBrandDirectory();
    initialiseBreadcrumbMeasurement();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
}());
